/**
 * Generated by orval 🍺
 * Do not edit manually.
 * lcm-microservice
 * OpenAPI spec version: 1.0.0
 */
export const RTBFormatEnum = {
    MPU: 'MPU',
    BANNER: 'BANNER',
    MINI_BANNER: 'MINI_BANNER',
    INTERSTITIEL: 'INTERSTITIEL',
    INTERSTITIEL_PARALLAX: 'INTERSTITIEL_PARALLAX',
    SKIN: 'SKIN',
    NATIVE: 'NATIVE',
    INSTREAM: 'INSTREAM',
    MEGA_BANNER: 'MEGA_BANNER',
    WIDE_ANGLE: 'WIDE_ANGLE',
    SKYSCRAPER: 'SKYSCRAPER',
    WIDE_SKYSCRAPER: 'WIDE_SKYSCRAPER',
    MASTHEAD: 'MASTHEAD',
    HOMEHEADER: 'HOMEHEADER',
    AUDIO: 'AUDIO',
};
